import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import API from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    const processSession = async () => {
      try {
        const res = await API.post("/auth/session", {
          session_id: sessionId,
        });
        setUser(res.data);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch {
        navigate("/login");
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="flex items-center justify-center h-screen bg-[#FFFFFF]">
      <p className="text-[#787774] text-2xl italic">
        Authenticating...
      </p>
    </div>
  );
}
